<div class="confirmation-modal-container">
  @if (!data.simpleDialog) {
    @if (data.action || data.title) {
      <h2 class="confirmation-modal-header">
        @if (data.action) {
          Are you sure you want to {{ data.action }}?
        } @else {
          {{ data.title }}?
        }
      </h2>
    }
    @if (data.description) {
      <div class="preText">{{ data.description }}</div>
    }
    <div style="padding: 0 24px">
      <ng-template #dynamicInsert></ng-template>
    </div>
    @if (data.textMatcherValue) {
      <div class="confirmation-modal-text-matcher">
        <p>
          <b>This action is permanent and cannot be undone.</b> If you are sure,
          please type "{{ data.textMatcherValue }}" in the filed below
        </p>
        <mat-form-field
          appearance="outline"
          class="value-description"
          subscriptSizing="dynamic"
        >
          <mat-label>Type {{ data.textMatcherValue }} to confirm</mat-label>
          <input
            data-testid="confirm-delete"
            matInput
            type="text"
            [(ngModel)]="textMatcherValue"
          />
        </mat-form-field>
      </div>
    }
    @if (data.okButtonText == 'Decline Invitation') {
      <div>
        <mat-form-field
          style="display: block"
          appearance="outline"
          floatLabel="always"
          class="mat-body-2"
        >
          <mat-label>Reason for declining (optional)</mat-label>
          <textarea
            style="height: 100px"
            autoFocus
            matInput
            forbidAngleBrackets
            matTextareaAutosize
            [(ngModel)]="declineReason"
            class="text-area"
          ></textarea>
        </mat-form-field>
      </div>
    }
    <div mat-dialog-actions>
      <button
        mat-flat-button
        [ngClass]="data.delete ? 'mat-warn' : 'mat-primary'"
        [mat-dialog-close]="true"
        [disabled]="isMainButtonDisabled()"
        (click)="save()"
        id="ok-button"
      >
        {{ data.okButtonText ? data.okButtonText : 'Ok' }}
      </button>
      <button
        type="button"
        class="close-button"
        mat-button
        [mat-dialog-close]="false"
        id="cancel-button"
      >
        Cancel
      </button>
    </div>
  } @else {
    <h2 class="confirmation-modal-header">{{ data.title }}</h2>
    @if (data.description) {
      <div class="confirmation-modal-description">
        {{ data.description }}
      </div>
    }
    <div style="padding: 0 24px">
      <ng-template #dynamicInsert></ng-template>
    </div>
    <div mat-dialog-actions>
      <button
        [attr.id]="data.okButtonId"
        mat-flat-button
        [ngClass]="data.delete ? 'mat-warn' : 'mat-primary'"
        [mat-dialog-close]="true"
        [disabled]="isMainButtonDisabled()"
      >
        {{ data.okButtonText ? data.okButtonText : 'Ok' }}
      </button>
      <button
        type="button"
        class="close-button"
        mat-button
        [mat-dialog-close]="false"
      >
        CANCEL
      </button>
    </div>
  }
</div>
